export const SandboxPatients = [
    {
        name: 'Lopez, Camila',
        mockName: 'Demo Patient',
        patientId: 'Z6129'
    },
    {
        name: 'Lin, Derek',
        mockName: 'Yuval Talby',
        patientId: 'Z6127'
    },
    {
        name: 'Powell, Desiree',
        mockName: 'Ryan Brown',
        patientId: 'Z6130'
    },
    {
        name: 'Davis, Elijah',
        mockName: 'Itay Leybovitch',
        patientId: 'Z6125'
    },
    {
        name: 'Ross, Linda',
        mockName: 'Harel Dagan',
        patientId: 'Z6128'
    },
    {
        name: 'Roberts, Olivia',
        mockName: 'Adam VDK',
        patientId: 'Z6131'
    },
    {
        name: 'McGinnis, Warren',
        mockName: 'Dan Tsir Cohen',
        patientId: 'Z6126'
    },
    {
        name: 'Cadence, Anna',
        mockName: 'Shlomi Uziel',
        patientId: 'Z4529'
    },
    {
        name: 'Clin Doc, Henry',
        mockName: 'Chen Shapira',
        patientId: 'Z4648'
    },
    {
        name: 'Grand Central, John',
        mockName: 'Nadav Elyakim',
        patientId: 'Z4579'
    },
    {
        name: 'Optime, Omar',
        mockName: 'Guy Barash',
        patientId: 'Z4951'
    },
    {
        name: 'Nelson, Kyle',
        mockName: 'Patrycja Zaslawskaa',
        patientId: 'Z5591'
    }
];
export const Default_EHRID = '0cd819c692decf55f41710cdcfee187c';
export const Const_EHRInstances = [
    {
        '_id': '18984643f6e5491271d6c81e7a8190ce',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `Deploy`,
        'knowledgeBaseVersion': '1.0.0'
    },
    {
        '_id': '0cd819c692decf55f41710cdcfee187c',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `Quai Demo EHR`,
        'knowledgeBaseVersion': '1.0.0'
    },
    {
        '_id': 'a4b57af3dbd94327bc85aa2e279659c4',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `MUSC Testing`,
        'knowledgeBaseVersion': '1.0.0'
    },
    {
        '_id': 'da62ad1c167d2764a6ca82cb51563f34',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `Orangeburg Testing`,
        'knowledgeBaseVersion': '1.0.0'
    },
    {
        '_id': '8f3673e77beca409ea77d529c33f1183',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `Mayo Testing`,
        'knowledgeBaseVersion': '1.0.0'
    },
    {
        '_id': '8c4320d9979d2efe4cacabd2daca185a',
        'organizationId': '4c813b976331c152edbfd03e1b52d2e6',
        'label': `Mayo Deploy`,
        'knowledgeBaseVersion': '1.0.0'
    },
];
//# sourceMappingURL=sandbox-patients.js.map